import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Auth } from 'aws-amplify';
import { InputText } from 'primereact/inputtext';

import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import Layout from "../../../components/common/nav/initiator/nav.component";
import { checkDuplicates, ConvertResponseForSelect, ConvertResponseForSelectWithRefCode, getResponseFromKeyCertifiedAdmin, graphQLGetAllData, graphQLFindRecordById } from '../../../helper/commonfunctions';
import { Request_Status } from '../../../helper/enum';
import { ValidateApproverRole } from '../../../helper/validateRole';
import { AbsentCode, Employee, InitiateClassifiedWeeklyAbsenceReport, CertificatedAdminWeeklyAbsenceReport, CertificatedAdminWeeklyAbsenceReportEmployee, CertificatedAdminWeeklyAbsenceReportEmployeeDetails, InitiateClassifiedWeeklyAbsenceReportEmployee, InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, Schools } from '../../../models';
import Login from '../../../setup/auth/login.component';
import { Tooltip } from 'primereact/tooltip';
import AWS from "aws-sdk";
import { USER_TYPES, USER_TYPES_NAMES } from "../../../helper/enum";
import awsmobile from "../../../aws-exports";
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../graphql/mutations';
import { designationForAllApps } from '../../../helper/enum';
import * as queries from "../../../graphql/queries";

export default function WAR_Certificated_Admin_Initiate_Request_Approver() {

    const loggedUserId = reactLocalStorage.get('loggedUserId');
    const loggedl2authority = reactLocalStorage.get('loggedl2authority');
    const { reportId } = useParams();
    const [periodDates, setPeriodDates] = useState([]);
    const [schoolList, setSchoolList] = useState([]);
    const [absentCodeList, setAbsentCodeList] = useState([]);
    const [absentCodeListDropdown, setAbsentCodeListDropdown] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [employeeTypeField, setEmployeeTypeField] = useState("");

    const [absentCode, setAbsentCode] = useState([]);
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [absentDate, setAbsentDate] = useState([]);
    const [openNewEmployee, setOpenNewEmployee] = useState(false);
    const [visible, setVisible] = useState(false);
    const [employeeList, setEmployeeList] = useState();
    const [updatedEmpList, setUpdatedEmpList] = useState();
    const [allEmployeeList, setAllEmployee] = useState();
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const [disabled, setDisabled] = useState(false);
    let navigateTo = useNavigate();
    const [NewEmployeeSchool, setNewEmployeeSchool] = useState(null);
    const employeeTypeList = [{ name: "Administrator", code: "Administrator" }, { name: "Certificated", code: "Certificated" }]
    const [visibleSumbit, setVisibleSumbit] = useState(false);
    const [visibleDialogue, setVisibleDialogue] = useState(false);
    const [mappedData, setMappedData] = useState([]);
    const existingResultsAdministrator = mappedData.filter(item => item.employeeType === 'Administrator');
    const existingResultsCertifiedCertificated = mappedData.filter(item => item.employeeType === 'Certificated');
    const [selectedDateRecord, setSelectedDateRecord] = useState([]);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);

    // const [NewEmployeeName, setNewEmployeeName] = useState('');
    const [newEmpFirstName, setNewEmpFirstName] = useState('');
    const [newEmpLastName, setNewEmpLastName] = useState('');
    const rolesArray = [
        { name: 'Initiator', code: 'I' },
        { name: 'Approver', code: 'AP' },
        { name: 'Payroll', code: 'P' },
    ];
    const [newEmpSelectedRole, setNewEmpSelectedRole] = useState(null);
    const [newEmpSelectedDesignation, setNewEmpSelectedDesignation] = useState(null);


    const [NewEmployeeCode, setNewEmployeeCode] = useState('');
    const [NewEmployeeEmail, setNewEmployeeEmail] = useState('');
    const [dateCount, setDateCount] = useState(0);
    const [isShowSelectedDate, setIsShowSelectedDate] = useState(false);
    const [SelectperiodExpand, setActivate] = useState("");
    const [selectApprover, SetSelectApprover] = useState()
    const [allUserList, setAllUsersList] = useState([]);
    const [disabledDates, setDisabledDates] = useState([]);
    const [allSchoolList, setAllSchoolList] = useState([]);
    const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);

    //onclick remove container details
    const onClickRemoved = (index, detailIndex, detail) => {
        let data = [...mappedData];
        //set disabledates
        var indexofdate = disabledDates.indexOf(detail.selectedDate);
        let newDates = disabledDates.splice(indexofdate);
        setDisabledDates(disabledDates.filter(item => item !== detail.selectedDate))


        if (data[index].employeeResponse.length === 1) {
            data.splice(index, 1)
            setMappedData(data)
        } else {
            data[index].employeeResponse.splice(detailIndex, 1)
            setMappedData(data)
        }

    }

    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });


    const toggleActiveexpand = () => { setActivate(SelectperiodExpand === "SelectperiodExpand" ? "" : "SelectperiodExpand") };

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateApproverRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    //*onClick Select Period
    const onClickDates = async (date) => {

        // let empName = await DataStore.query(Employee, (c) => c.id.eq(selectedEmployee.code
        // ));
        let empName = allEmployeeList.find(o => o.id === selectedEmployee.code)

        setSelectedDateRecord([]);
        setIsShowSelectedDate(true)
        let newResponse = [];
        for (let i = 0; i < date.length; i++) {
            let data = {
                "employeeName": selectedEmployee.name,
                "selectedDate": date[i],
                "displayDate": date[i],
                "absentCode": { "name": "", "code": "" },
                "absentId": "",
                "employeeType": empName.employeeType,
                "nameOfTheSubstitute": '',
                "hour": '',
                "minute": ''
            }
            newResponse.push(data)
            if (i === date.length - 1) {
                setSelectedDateRecord(newResponse)
            }
        }
    };



    const SaveUserToCognito = async (newEmployeeId) => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        const userPoolId = awsmobile.aws_user_pools_id;
        const username = NewEmployeeEmail
        const password = "Gusd@2023"
        const Permanent = true

        let attributes = [
            {
                Name: 'email',
                Value: NewEmployeeEmail
            },
            {
                Name: 'custom:firstName',
                Value: newEmpFirstName
            },
            {
                Name: 'custom:lastName',
                Value: newEmpLastName
            },
            {
                Name: 'name',
                // Value: NewEmployeeName
                Value: newEmpLastName.toLowerCase() + ", " + newEmpFirstName.toUpperCase()
            },
            {
                Name: 'custom:userCode',
                Value: NewEmployeeCode
            },
            // {
            //     Name: 'custom:city',
            //     Value: city
            // },
            // {
            //     Name: 'custom:mobileNumber',
            //     Value: phoneNo
            // },
            // {
            //     Name: 'custom:address',
            //     Value: addressOne
            // },
            // {
            //     Name: 'custom:stateId',
            //     Value: state
            // },
            // {
            //     Name: 'custom:countryId',
            //     Value: country
            // },
            // {
            //     Name: 'custom:userType',
            //     Value: userType.label
            // },
            {
                Name: 'custom:empId',
                Value: newEmployeeId
            },

        ];

        const params = {
            UserPoolId: userPoolId,
            Username: username,
            UserAttributes: attributes
        };

        const params2 = {
            UserPoolId: userPoolId,
            Username: username,
            Password: password,
            Permanent: Permanent,
        };

        let userSub;
        try {
            const createUserResponse = await cognito.adminCreateUser(params).promise();
            console.log('Employee confirmed and saved successfully', createUserResponse);
            userSub = createUserResponse.User?.Attributes?.find(attr => attr.Name === 'sub')?.Value;
            // setUserSub(userSub);
            // toast.success("Employee confirmed and saved successfully")

            // User Confirmation 
            cognito.adminSetUserPassword(params2, (err, data) => {
                if (err) {
                    console.log('Error confirming user:', err);
                } else {
                    console.log('User confirmed successfully:', data);
                }
            });

        } catch (error) {
            toast.error("Employee already exist.")
            setOpenNewEmployee(false)
            setNewEmployeeSchool(null);
            // setNewEmployeeName("");
            setNewEmpFirstName("");
            setNewEmpLastName("");
            setNewEmpSelectedRole(null);
            setNewEmpSelectedDesignation(null);

            setNewEmployeeCode("");
            setNewEmployeeEmail("");
            console.error('Error saving Cognito user:', error);
        }



        if (userSub !== null) {
            //Update Employee with Cognito UserId
            const original = await API.graphql(
                graphqlOperation(queries.getEmployee,
                    { id: newEmployeeId }
                )
            );
            // await DataStore.query(Employee, newEmployeeId);
            await API.graphql(
                graphqlOperation(mutations.updateEmployee, {
                    input: {
                        id: original?.data?.getEmployee?.id,
                        user_Id: userSub,
                        _version: original?.data?.getEmployee?._version,
                    }
                }))
        }


    }


    const AddNewEmployee = async () => {
        if (selectedSchool === "" || selectedSchool === null) {
            toast.error("Please Select School/Department");
            return;
        } 
        // else if (NewEmployeeName === null || NewEmployeeName === "") {
        //     toast.error("Please Enter Employee Name");
        //     return;
        // }
        else if (newEmpFirstName === null || newEmpFirstName === "") {
            toast.error("Please Enter Employee First Name");
            return;
        }
        else if (newEmpLastName === null || newEmpLastName === "") {
            toast.error("Please Enter Employee Last Name");
            return;
        }
        // else if (newEmpSelectedRole === null) {
        //     toast.error("Please Select Employee Role");
        //     return;
        // }
        // else if (newEmpSelectedDesignation === null) {
        //     toast.error("Please Select Employee Designation");
        //     return;
        // }

         else if (NewEmployeeCode === "") {
            toast.error("Please Enter Employee Code");
            return;
        } else if (NewEmployeeEmail === null || NewEmployeeEmail === "") {
            toast.error("Please Enter Employee Email");
            return;
        } else if (employeeTypeField === null || employeeTypeField === "") {
            toast.error("Please Enter Employee Type");
            return;
        }

        // var AddedNewEmployee = await DataStore.save(new Employee(
        //     {
        //         "school_id": selectedSchool?.code,
        //         "employee_name": NewEmployeeName,
        //         "employee_code": NewEmployeeCode,
        //         "email": NewEmployeeEmail,
        //         "employeeType": employeeTypeField ? employeeTypeField.code : employeeTypeField

        //     }
        // ))

        const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])

        if (matchedEmailRecord.length == 0) {
        var AddedNewEmployee = await API.graphql(
            graphqlOperation(mutations.createEmployee, {
                input: {
                    school_id: selectedSchool?.code,
                    // employee_name: NewEmployeeName,

                    firstName: newEmpFirstName.toUpperCase(),
                    lastName: newEmpLastName.toLowerCase(),
                    employee_name: newEmpLastName.toLowerCase() + ", " + newEmpFirstName.toUpperCase(),
                    // role: newEmpSelectedRole?.code,
                    // designation: newEmpSelectedDesignation.code,
                    employee_code: NewEmployeeCode,
                    email: NewEmployeeEmail,
                    employeeType: employeeTypeField ? employeeTypeField.code : employeeTypeField
                }
            })
        );
        getMasterData();

        if (AddedNewEmployee?.data?.createEmployee?.id !== null) {
            //Save Cognito User
            await SaveUserToCognito(AddedNewEmployee?.data?.createEmployee?.id);
        }
        if(AddedNewEmployee){
        toast.success('Data Added Successfully.');
        try {


            var employeeResponses = await graphQLGetAllData("listEmployees", [{ school_id: { eq: AddedNewEmployee.data.createEmployee.school_id } }])
            //--------------
            // var employeeResponses = allEmployeeList.filter(e => e.school_id !== null && e.school_id.includes(AddedNewEmployee.data.createEmployee.school_id))
            employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

            if (employeeResponses !== null) {
                let employeeData = employeeResponses;

                let employee = [];
                employeeData.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.id
                    }
                    employee.push(obj);
                })

                setEmployeeList(employee);

                setUpdatedEmpList(employee);
            }
        }
        catch (error) { }

        let obj = {
            name: (AddedNewEmployee.data.createEmployee.employee_name + ' ' + '(' + AddedNewEmployee.data.createEmployee.employee_code + ')'),
            code: AddedNewEmployee.data.createEmployee.id
        }



        setSelectedEmployee(obj);

        setOpenNewEmployee(false)
        setNewEmployeeSchool(null);
        // setNewEmployeeName("");
        setNewEmpFirstName("");
        setNewEmpLastName("");
        setNewEmpSelectedRole(null);
        setNewEmpSelectedDesignation(null);

        setNewEmployeeCode("");
        setNewEmployeeEmail("");
    }
    }else {
        toast.error("Please Use Another Email");
    }

    }

    //*onClick Select Period
    const onClickAbsentCode = (index, event) => {
        let absentCode = event.target.value
        let data = [...selectedDateRecord];
        data[index]["absentCode"] = absentCode;
        data[index]["absentId"] = absentCode.code;
        setSelectedDateRecord(data)
    };

    //*onClick Select Period
    const onClickNameOfSubstitute = (index, event) => {
        let nameOfTheSubstitute = event.target.value
        let data = [...selectedDateRecord];
        data[index]["nameOfTheSubstitute"] = nameOfTheSubstitute;
        data[index]["nameOfTheSubstituteId"] = absentCode.code;
        setSelectedDateRecord(data)
    };

    //*onClick Houre
    const onClickHoure = (index, value) => {
        let data = [...selectedDateRecord];
        data[index]["hour"] = value;
        setSelectedDateRecord(data)
    };

    //*onClick Min
    const onClickMin = (index, value) => {
        let data = [...selectedDateRecord];
        data[index]["minute"] = value;
        setSelectedDateRecord(data)
    };

    //onclick remove container details
    const onClickRemove = (index, detailIndex, detail) => {
        let data = [...mappedData];
        //set disabledates
        setDisabledDates(disabledDates.filter(item => item !== detail.selectedDate))

        if (data[index].employeeResponse.length === 1) {
            data.splice(index, 1)
            setMappedData(data)
        } else {
            data[index].employeeResponse.splice(detailIndex, 1)
            setMappedData(data)
        }


    }

    async function LoadUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60
            };

            ///fetch users
            try {
                const data = await cognito.listUsers(params).promise();

                var newRes = []
                let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                data.Users.forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    let obj = {
                        "userId": sub,
                        "name": userName,
                        "email": userEmail,
                        "usercode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );

                let usersWithoutAdmin = [];
                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin') {
                        usersWithoutAdmin.push(currentItem);
                    }
                })

            } catch (err) {
                console.log(err);
            }
            //-------------

            cognito.listUsers(params, (err, data) => {
                if (err) {
                    console.log(err);
                    toast.error(err.message);
                } else {

                    const roles = [];
                    var newRes = []
                    var role = "";
                    var name = "";
                    var sub = "";
                    var email = "";
                    var usercode = "";
                    let withoutAdminUsers = [];
                    let payrollUser = []

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        let newUser = {
                            "userId": sub,
                            "name": name,
                            "email": email,
                            "usercode": usercode,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }
                        newRes.push(newUser);

                        if (i === data.Users.length - 1) {

                            for (let i = 0; i < newRes.length; i++) {
                                const user = newRes[i];
                                const roleIndex = roles.findIndex(role => role.role === user.role);


                                if (roleIndex === -1) {
                                    roles.push({ role: user.role, count: 1, users: [user], email: user.email, name: user.name, usercode: user.usercode });
                                } else {
                                    roles[roleIndex].count++;
                                    roles[roleIndex].users.push(user);
                                }
                            }
                        }

                        if (role === USER_TYPES.APPROVER) {
                            let userObj = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            withoutAdminUsers.push(userObj);
                        }

                        if (role === USER_TYPES.PAYROLL) {
                            let userObjs = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            payrollUser.push(userObjs);
                        }
                    });

                    let sortArray = newRes.sort((a, b) => (a.name > b.name ? 1 : -1))


                    var userList = sortArray.map((currentItem) => {
                        return (
                            { code: currentItem.userId, name: currentItem.name }
                        )
                    })
                    const matchedItem = newRes.find(item => item.userId === loggedl2authority);
                    // SetSelectApprover({ name: matchedItem.name, code: matchedItem.userId })
                    setAllUsersList(userList)
                }
            });

        } catch (e) {
            toast.error(e.message);
        }

    }

    const currentDateTime = moment();

    async function EmployeeList(e) {
        let schoolId = e.value.code;
        setSelectedSchool(e.value)
        try {
            // var employeeResponses = await DataStore.query(Employee, (c) => c.school_id.eq(schoolId),
            //     {
            //         sort: s => s.employee_name(SortDirection.ASCENDING),
            //     }
            // );

            var employeeResponses = allEmployeeList.filter(e => e.school_id && e.school_id.includes(schoolId))
            employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));


            if (employeeResponses !== null) {
                let employeeData = employeeResponses;

                let filteredTypeData = employeeData.filter(item => {
                    const employeeType = item.employeeType;
                    return employeeType === "Certificated" || employeeType === "Administrator";
                });

                let employee = [{ name: "No Absence", code: "1" }];
                filteredTypeData.map((item) => {
                    if (item.employeeType === 'Certificated' || item.employeeType === 'Administrator') {
                        let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                        let obj = {
                            name: name,
                            code: item.id
                        }
                        employee.push(obj);
                    }

                })
                setEmployeeList(employee);

            }
        }
        catch (error) { }
    }


    async function BindList() {
        // var employeeList = await DataStore.query(Employee, Predicates.ALL)

        // setAllEmployee(employeeList)

        // var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });
        // var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);

        // var AbsentCodeResponses = await DataStore.query(AbsentCode, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });
        // setAbsentCodeList(AbsentCodeResponses)
        // var myArray = []; myArray = ConvertResponseForSelectWithRefCode(AbsentCodeResponses); setAbsentCodeListDropdown(myArray);

        if (reportId) {
            getData()
        }
    }

    //*get Existing Data
    const getData = async () => {
        if (reportId) {
            setVisible(true)
            setDisabled(true);
            // var getAbsenceReport = await DataStore.query(CertificatedAdminWeeklyAbsenceReport, reportId)
            var getAbsenceReport = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", reportId)

            let to_date = new Date(moment(getAbsenceReport.to_date).format("YYYY-MM-DD")); let from_date = new Date(moment(getAbsenceReport.from_date).format("YYYY-MM-DD"));
            let dateArray = [from_date, to_date]; setPeriodDates(dateArray);
            // var getAbsenceReportOfEmployee = await DataStore.query(Schools, (c) => c.id.eq(getAbsenceReport.school_id))
            var getAbsenceReportOfEmployee = await graphQLFindRecordById("getSchools", getAbsenceReport.school_id)

            setSelectedSchool({ name: getAbsenceReportOfEmployee.name, code: getAbsenceReportOfEmployee.id })
            // var employeeResponses = await DataStore.query(Employee,
            //     (c) => c.school_id.eq(getAbsenceReport.school_id),
            //     Predicates.ALL, { sort: s => s.employee_name(SortDirection.ASCENDING) }
            // );

            var employeeResponses = allEmployeeList.filter(e => e.school_id && e.school_id.includes(getAbsenceReport.school_id));
            employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

            if (employeeResponses !== null) {
                let employeeData = employeeResponses;
                let employee = [];
                employeeData.map((item) => {
                    let obj = {
                        name: (item.employee_name + ' ' + '(' + item.employee_code + ')'),
                        code: item.id
                    }
                    employee.push(obj);
                })
                setEmployeeList(employee);
            }
            if (getAbsenceReport) {
                // var getAbsenceReportOfEmployee = await DataStore.query(CertificatedAdminWeeklyAbsenceReportEmployee, (c) => c.Certificated_Admin_Weekly_Absence_Report_id.eq(getAbsenceReport.id))

                var getAbsenceReportOfEmployee = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: getAbsenceReport.id } }])


                let newResponse = [];
                for (var i = 0; i < getAbsenceReportOfEmployee.length; i++) {

                    let employeeResponse = await getEmployeeDetails(getAbsenceReportOfEmployee[i].id, getAbsenceReportOfEmployee[i].employee_id);
                    // let empName = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployee[i].employee_id));
                    let empName = allEmployeeList.find(o => o.id === getAbsenceReportOfEmployee[i].employee_id)
                    let data = {
                        "employeeName": empName.employee_name,
                        "employeeId": getAbsenceReportOfEmployee[i].employee_id,
                        "employeeResponse": employeeResponse
                    }

                    if (newResponse.length > 0) {
                        newResponse = [...newResponse, data];
                    } else {
                        newResponse.push(data)
                    }

                    if (i === getAbsenceReportOfEmployee.length - 1) {
                        setMappedData(newResponse)
                        setVisible(true);
                    }
                }
            }
        }
    }

    //*All state clear
    const getEmployeeDetails = async (employeeDetailId, employeeId) => {
        let newResponse = [];
        // var getAbsenceReportOfEmployeeDetails = await DataStore.query(CertificatedAdminWeeklyAbsenceReportEmployeeDetails, (c) => c.Certificated_Admin_Weekly_Absence_Report_Employee_id.eq(employeeDetailId))

        var getAbsenceReportOfEmployeeDetails = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: employeeDetailId } }])

        for (var i = 0; i < getAbsenceReportOfEmployeeDetails.length; i++) {

            let employeeName = ""; let substituteEmployeeName = "";
            // let empResponse = await DataStore.query(Employee, (c) => c.id.eq(employeeId));
            let empResponse = allEmployeeList.find(o => o.id === employeeId)

            if (empResponse) { employeeName = empResponse.employee_name } else { employeeName = "" }
            // let substituteResponse = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployeeDetails[i].substitute_emp_id))
            let substituteResponse = allEmployeeList.find(o => o.id === getAbsenceReportOfEmployeeDetails[i].substitute_emp_id)

            if (substituteResponse) { substituteEmployeeName = substituteResponse.employee_name; } else { substituteResponse = ""; }
            // var getAbsentCodeDetails = await DataStore.query(AbsentCode, (c) => c.id.eq(getAbsenceReportOfEmployeeDetails[i].absent_code_id))
            var getAbsentCodeDetails = absentCodeList.find(o => o.id === getAbsenceReportOfEmployeeDetails[i].absent_code_id)

            let getAbsentCodeObj;
            if (getAbsentCodeDetails) { getAbsentCodeObj = { "name": getAbsentCodeDetails.name + " (" + getAbsentCodeDetails.code + ")", "code": getAbsentCodeDetails.id } } else { getAbsentCodeObj = { "name": "", "code": "" } }

            newResponse.push({
                "employeeName": employeeName, "selectedDate": getAbsenceReportOfEmployeeDetails[i].absent_date, "displayDate": getAbsenceReportOfEmployeeDetails[i].absent_date, "absentCode": getAbsentCodeObj, "absentId": getAbsenceReportOfEmployeeDetails[i].absent_code_id,
                "nameOfTheSubstitute": { "name": substituteEmployeeName, "code": getAbsenceReportOfEmployeeDetails[i].substitute_emp_id }, "nameOfTheSubstituteId": getAbsenceReportOfEmployeeDetails[i].substitute_emp_id, "hour": getAbsenceReportOfEmployeeDetails[i].partial_hour, "minute": getAbsenceReportOfEmployeeDetails[i].partial_min,
            })

            if (i === getAbsenceReportOfEmployeeDetails.length - 1) {
                return newResponse
            }
        }
    };

    //All state clear
    const stateClear = () => {
        setAbsentDate([])
    };

    //Create  Initiate New Report
    const applyReport = async () => {
        setDisabled(true)
        if (selectedSchool !== null && selectedEmployee !== null && periodDates.length > 0 && selectedDateRecord[0].hour !== null) {
            //*set data to table
            if (mappedData.length > 0) {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKeyCertifiedAdmin(data, removeDuplicateArray, selectedEmployee.code, selectedDateRecord[0].employeeType);
                let object = getResponse[0];
                let myArray = [...mappedData, object];
                setMappedData(myArray);
                setSelectedDateRecord([]);
            } else {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKeyCertifiedAdmin(data, removeDuplicateArray, selectedEmployee.code, selectedDateRecord[0].employeeType)
                setMappedData(getResponse);
                setSelectedDateRecord([]);
            }

            //disable date 
            let datesArray = []
            for (let i = 0; i < selectedDateRecord.length; i++) {
                datesArray[i] = selectedDateRecord[i].selectedDate
            }
            //let date
            let updatedList = [...disabledDates, ...datesArray]
            setDisabledDates(updatedList)


            setVisible(true);
            stateClear()
        } else {
            toast.error("Select mandatory fields.")
            if (reportId) { setVisible(true); } else { setVisible(false); }
        }

    }

    const goBack = () => {
        navigateTo("/approver/weekly_absent_report_certificated_admin");
    }

    //*save Report
    const saveReport = async (status) => {
        setPleaseWaitButton(false);
        if (reportId) {
            // debugger;
            // await DataStore.delete(CertificatedAdminWeeklyAbsenceReport, (c) => c.id.eq(reportId)).then(async (response) => {
            //     await DataStore.delete(CertificatedAdminWeeklyAbsenceReportEmployee, (c) => c.Certificated_Admin_Weekly_Absence_Report_id.eq(reportId)).then(async (response) => {
            //         await DataStore.delete(CertificatedAdminWeeklyAbsenceReportEmployeeDetails, (c) => c.Certificated_Admin_Weekly_Absence_Report_Employee_id.eq(response.id)).then(async (response) => {
            //             CommenFunction(status)
            //         })
            //     })
            // })

            // Need to test
            let firstQuery = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", reportId)
            await API.graphql({
                query: mutations.deleteCertificatedAdminWeeklyAbsenceReport,
                variables: {
                    input: {
                        id: firstQuery.id,
                        _version: firstQuery._version
                    }
                }
            });

            let secondQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: reportId } }])

            for (let j = 0; j < secondQuery.length; j++) {
                let deletedRecord = await API.graphql({
                    query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployee,
                    variables: {
                        input: {
                            id: secondQuery[j].id,
                            _version: secondQuery[j]._version
                        }
                    }
                });

                let thirdQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: deletedRecord.data.deleteCertificatedAdminWeeklyAbsenceReportEmployee.id } }])

                for (let k = 0; k < thirdQuery.length; k++) {
                    await API.graphql({
                        query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails,
                        variables: {
                            input: {
                                id: thirdQuery[k].id,
                                _version: thirdQuery[k]._version
                            }
                        }
                    });
                }
            }
            CommenFunction(status)
        } else {
            // debugger;
            CommenFunction(status)
        }
    }

    const CommenFunction = async (status) => {

        // save ALL data to datastore
        var newInitiateClassifiedWeeklyAbsenceReportId;
        // var InitiateClassifiedWeeklyAbsenceReportId = await DataStore.save(
        //     new CertificatedAdminWeeklyAbsenceReport({
        //         "user_id": loggedUserId,
        //         "from_date": moment(periodDates[0]).format("YYYY-MM-DD"),
        //         "to_date": moment(periodDates[1]).format("YYYY-MM-DD"),
        //         "status": status,
        //         "approver_status": Request_Status.AP,
        //         "approver_by": loggedUserId,
        //         "l2_authority": "c7eea0c2-9c89-46e7-b297-5e077767585b",
        //         "l1_authority": loggedUserId,
        //         "approver_date_time": moment(currentDateTime).toISOString(),
        //         "school_id": selectedSchool.code,
        //         "status_date_time": moment(currentDateTime).toISOString()
        //     })
        // );

        var InitiateClassifiedWeeklyAbsenceReportId = await API.graphql(
            graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReport, {
                input: {
                    user_id: loggedUserId,
                    from_date: moment(periodDates[0]).format("YYYY-MM-DD"),
                    to_date: moment(periodDates[1]).format("YYYY-MM-DD"),
                    status: status,
                    approver_status: Request_Status.AP,
                    approver_by: loggedUserId,
                    l2_authority: "c7eea0c2-9c89-46e7-b297-5e077767585b",
                    l1_authority: loggedUserId,
                    approver_date_time: moment(currentDateTime).toISOString(),
                    school_id: selectedSchool.code,
                    status_date_time: moment(currentDateTime).toISOString()
                }
            })
        );

        newInitiateClassifiedWeeklyAbsenceReportId = InitiateClassifiedWeeklyAbsenceReportId.data.createCertificatedAdminWeeklyAbsenceReport.id;

        if (newInitiateClassifiedWeeklyAbsenceReportId) {

            for (var i = 0; i < mappedData.length; i++) {

                //Save InitiateClassifiedWeeklyAbsenceReportEmployee
                // var initiateClassifiedWeeklyAbsenceReportEmployee = await DataStore.save(
                //     new CertificatedAdminWeeklyAbsenceReportEmployee({
                //         "Certificated_Admin_Weekly_Absence_Report_id": newInitiateClassifiedWeeklyAbsenceReportId,
                //         "employee_id": mappedData[i].employeeId,
                //         "employee_type": mappedData[i].employeeType,
                //     })
                // ).then(async (data) => {
                //     saveEmployeeDetails(data.id, mappedData[i].employeeResponse)
                // })

                var initiateClassifiedWeeklyAbsenceReportEmployee = await API.graphql(
                    graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployee, {
                        input: {
                            Certificated_Admin_Weekly_Absence_Report_id: newInitiateClassifiedWeeklyAbsenceReportId,
                            employee_id: mappedData[i].employeeId,
                            employee_type: mappedData[i].employeeType,
                        }
                    })
                );

                saveEmployeeDetails(initiateClassifiedWeeklyAbsenceReportEmployee.data.createCertificatedAdminWeeklyAbsenceReportEmployee.id, mappedData[i].employeeResponse)


                if (i === mappedData.length - 1) {
                    toast.success('Data Added Successfully.');
                    { goBack() }
                }
            }
        }
    }

    //*Save Employee Details
    const saveEmployeeDetails = async (initiateClassifiedWeeklyAbsenceReportEmployeeId, employeeDetailsData) => {

        if (employeeDetailsData.length > 0) {
            for (let i = 0; i < employeeDetailsData.length; i++) {
                // await DataStore.save(
                //     new CertificatedAdminWeeklyAbsenceReportEmployeeDetails({
                //         "Certificated_Admin_Weekly_Absence_Report_Employee_id": initiateClassifiedWeeklyAbsenceReportEmployeeId,
                //         "absent_code_id": employeeDetailsData[i].absentCode.code,
                //         "substitute_emp_id": employeeDetailsData[i].nameOfTheSubstitute.code,
                //         "is_full_day": false,
                //         "partial_hour": employeeDetailsData[i].hour,
                //         "partial_min": employeeDetailsData[i].minute,
                //         "absent_date": moment(employeeDetailsData[i].selectedDate,).format("YYYY-MM-DD")
                //     })
                // );

                await API.graphql(
                    graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployeeDetails, {
                        input: {
                            Certificated_Admin_Weekly_Absence_Report_Employee_id: initiateClassifiedWeeklyAbsenceReportEmployeeId,
                            absent_code_id: employeeDetailsData[i].absentCode.code,
                            substitute_emp_id: employeeDetailsData[i].nameOfTheSubstitute.code,
                            is_full_day: false,
                            partial_hour: employeeDetailsData[i].hour,
                            partial_min: employeeDetailsData[i].minute,
                            absent_date: moment(employeeDetailsData[i].selectedDate,).format("YYYY-MM-DD")
                        }
                    })
                );

            }
        }
    }

    const CalendarValidation = () => {
        toast.error("Please select Employee.")
    }

    const onSetEmployee = (e) => {
        setSelectedEmployee(e.value);
        setDateCount(0);

        //create new list without selected employee
        let newEmpList = [];
        employeeList.map((currentItem) => {
            if (currentItem.code !== e.value.code) {
                newEmpList.push(currentItem);
            }
        })
        setUpdatedEmpList(newEmpList);
    }


    const getMasterData = async () => {
        let schoolsArray = await graphQLGetAllData("listSchools")
        schoolsArray = schoolsArray.sort((a, b) => a.name.localeCompare(b.name));

        var schoolArray = [];
        schoolArray = ConvertResponseForSelect(schoolsArray);
        setAllSchoolList(schoolsArray)
        setSchoolList(schoolArray);

        let employeeList = await graphQLGetAllData("listEmployees");
        setAllEmployee(employeeList);

        // var AbsentCodeResponses = await DataStore.query(AbsentCode, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        let AbsentCodeResponses = await graphQLGetAllData("listAbsentCodes");
        AbsentCodeResponses = AbsentCodeResponses.sort((a, b) => (a.name?.toLowerCase() ?? "").localeCompare(b.name?.toLowerCase() ?? ""));

        setAbsentCodeList(AbsentCodeResponses)
        var myArray = []; myArray = ConvertResponseForSelectWithRefCode(AbsentCodeResponses); setAbsentCodeListDropdown(myArray);

        setIsMasterDataLoaded(true)
    }

    useEffect(() => {
        onLoad();
        getMasterData();
        setVisibleDialogue(false);

    }, []);

    useEffect(() => {
        if (isMasterDataLoaded === true) {
            BindList();
            LoadUsers();
        }
    }, [isMasterDataLoaded]);


    return isAuthenticated ? (
        <>
            <Layout pageTitle="Homepage" activeMenu="Initiator" appId={"WEEKLY_ABSENCE_CERTIFIED"}>
                <div className="">
                    <div className="pt-24 md:pt-28 xl:pt-[2.083vw]">
                        <div className="">

                            <div className="text-[#113699] font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]">
                                <h3>Initiate New Report</h3>
                            </div>
                            <div className="mt-5 xl:mt-[1.250vw]">
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[0.833vw] cust-select">
                                    {/*------School or Departament-----*/}

                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of School or Department <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={selectedSchool}
                                                onChange={(e) => {
                                                    EmployeeList(e)
                                                    setDateCount(0);
                                                }}
                                                filter
                                                disabled={disabled}
                                                options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
                                    </div>

                                    {/*------School or Departament-----*/}
                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Employee <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative flex">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="employee"
                                                value={selectedEmployee}
                                                onChange={(e) => { onSetEmployee(e); setAbsentDate([]) }} options={employeeList}
                                                filter
                                                optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                            <div onClick={(e) => setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                                                {/* <i className='gusd-pluse-circle' style = {{color: "lightgray",fontSize: "20px", margin: "3px",position:"relative", bottom:"6px"}}></i> */}
                                                <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content" />
                                                <i className='icon-tooltip gusd-pluse-circle' style={{ color: "lightgray", fontSize: "20px", margin: "3px", position: "relative", bottom: "6px" }}></i>
                                            </div>
                                        </div>
                                    </div>



                                    {/* <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Payroll<span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="employee"
                                                value={selectApprover}
                                                onChange={(e) => { SetSelectApprover(e.value) }}
                                                options={allUserList}
                                                filter
                                                optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div> */}

                                    {/*-----Period----*/}
                                    <div className="w-full">
                                        <div className="">
                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Period <span className='text-[red] pl-0.2'>*</span></label> </div>
                                        <div className="w-full">
                                            <div className="relative custp-calender">
                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                                <div className="card justify-content-center">
                                                    {selectedEmployee === null && !reportId ?
                                                        <div onClick={() => CalendarValidation()}>
                                                            <Calendar
                                                                disabled={true}
                                                                placeholder="Date Range"
                                                                selectionMode="multiple"
                                                                className="w-full h-11" /> </div>

                                                        :
                                                        <Calendar
                                                            onChange={(e) => {
                                                                setPeriodDates(null);

                                                                setSelectedDateRecord([]);
                                                                setAbsentDate([])
                                                                const nextMinDate = new Date(e.value);
                                                                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                                                                let nextMaxDate = nextMinDate;
                                                                let dayNumber = moment(nextMinDate).day(); //nextMinDate.
                                                                if (dayNumber === 0 || dayNumber === 6) { setPeriodDates([]); toast.error("Please do not select Saturday or Sunday."); return }
                                                                let newDate = nextMinDate
                                                                let nextDate = nextMinDate.getDate()
                                                                nextMinDate.setDate(nextMinDate.getDate() - (dayNumber - 2));
                                                                let from = new Date(moment(nextMinDate).format("YYYY-MM-DD"));
                                                                nextMaxDate.setDate(nextMinDate.getDate() + 4);
                                                                let to = new Date(moment(nextMaxDate).format("YYYY-MM-DD"));
                                                                let dateArray = [from, to];
                                                                setPeriodDates(dateArray)
                                                            }}
                                                            value={periodDates}
                                                            minDate={minDate}
                                                            maxDate={maxDate}
                                                            disabled={disabled}
                                                            placeholder="Date Range"
                                                            selectionMode="range"
                                                            className="w-full h-11" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*-----Period----*/}
                                </div>
                            </div>

                            <div className="mt-5 xl:mt-[1.094vw] pb-10 ">
                                <div className="grid grid-cols-2 lg:grid-cols-12 gap-6 xl:gap-[1.250vw]">
                                    <div className="col-span-12 lg:col-span-8">
                                        <div id={SelectperiodExpand} className="box-shadow-1 bg-white">
                                            <div className="flex justify-between items-center p-4 xl:p-[0.833vw]">
                                                <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]"><p>Select Period</p></div>
                                                <div className=""><Button href={'/'} onClick={toggleActiveexpand} style={{ background: '#ffffff00', border: '0', padding: '0', width: '24px', height: '24px' }}><i className="gusd-expand text-base text-[#101828]"></i></Button></div>
                                            </div>
                                            <div className="custmCalendar p-4 xl:p-[0.833vw]">
                                                <Calendar value={absentDate} onChange={(e) => {
                                                    if (reportId) { if (selectedEmployee === null) { toast.error("Please Select Employee"); return; } else { onClickDates(e.value); setAbsentDate(e.value); } } else { onClickDates(e.value); setAbsentDate(e.value); }
                                                }}
                                                    minDate={new Date(moment(periodDates[0]).format("YYYY,M,DD"))}
                                                    maxDate={new Date(moment(periodDates[1]).format("YYYY,M,DD"))}
                                                    inline
                                                    disabledDates={selectedEmployee && selectedEmployee.code ? disabledDates[selectedEmployee.code] : ''}
                                                    selectionMode="multiple" />
                                            </div>
                                        </div>

                                        {/*---Preview Section---*/}
                                        <div className="mt-6 xl:mt-[1.250vw]">

                                            <div className="bg-white box-shadow-1">
                                                <div className="p-4 xl:p-[0.833vw] pb-0">
                                                    <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]">
                                                        <p>Preview - Administrator</p></div></div>

                                                <div className="px-3 xl:px-[0.677vw] custp-table-d initiatorperiodtable">
                                                    {
                                                        visible &&
                                                        <Paper>
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Name of Employee</TableCell>
                                                                        <TableCell>
                                                                            Dates Absent</TableCell>
                                                                        <TableCell>Absent Codes</TableCell>
                                                                        <TableCell>Total Hours</TableCell>
                                                                        <TableCell>Name of Substitute</TableCell>
                                                                        <TableCell>Action</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>

                                                                    {
                                                                        existingResultsAdministrator.map((item, i) => (

                                                                            <Fragment>
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        rowSpan={item.employeeResponse.length + 1}
                                                                                    >
                                                                                        {item.employeeName}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                                {item.employeeResponse.map((detail, detailIndex) => (

                                                                                    <TableRow>
                                                                                        <TableCell>{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>

                                                                                        <TableCell>{detail.absentCode.name}</TableCell>

                                                                                        <TableCell>
                                                                                            {detail.hour === null + "." && Number(detail.minute * 1.6666).toFixed(0) + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute * 1.6666).toFixed(0) === null ? detail.hour : detail.hour + "." === null && Number(detail.minute * 1.6666).toFixed(0) + " hr" !== null ? Number(detail.minute * 1.6666).toFixed(0) + "min" : detail.hour + "." + Number(detail.minute * 1.6666).toFixed(0) + " hr"}</TableCell>


                                                                                        <TableCell>{detail.nameOfTheSubstitute.name}</TableCell>
                                                                                        <TableCell>



                                                                                            <Link className='pi pi-trash ml-3  ' onClick={() => {
                                                                                                onClickRemove(i, detailIndex, detail)
                                                                                            }}></Link></TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </Fragment>
                                                                        ))
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </Paper>
                                                    }

                                                </div>
                                            </div>

                                            <div className="bg-white box-shadow-1">
                                                <div className="p-4 xl:p-[0.833vw] pb-0">
                                                    <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]">
                                                        <p>Preview - Certificated</p></div></div>
                                                <div className="px-3 xl:px-[0.677vw] custp-table-d initiatorperiodtable">
                                                    {
                                                        visible &&
                                                        <Paper>
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Name of Employee</TableCell>
                                                                        <TableCell>
                                                                            Dates Absent</TableCell>
                                                                        <TableCell>Absent Codes</TableCell>
                                                                        <TableCell>Total Hours</TableCell>
                                                                        <TableCell>Name of Substitute</TableCell>
                                                                        <TableCell>Action</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>

                                                                    {

                                                                        existingResultsCertifiedCertificated.map((item, i) => (

                                                                            <Fragment>
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        rowSpan={item.employeeResponse.length + 1}
                                                                                    >
                                                                                        {item.employeeName}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                                {item.employeeResponse.map((detail, detailIndex) => (

                                                                                    <TableRow>
                                                                                        <TableCell>{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>

                                                                                        <TableCell>{detail.absentCode.name}</TableCell>

                                                                                        <TableCell>
                                                                                            {detail.hour === null + "." && Number(detail.minute * 1.6666).toFixed(0) + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute * 1.6666).toFixed(0) === null ? detail.hour : detail.hour + "." === null && Number(detail.minute * 1.6666).toFixed(0) + " hr" !== null ? Number(detail.minute * 1.6666).toFixed(0) + "min" : detail.hour + "." + Number(detail.minute * 1.6666).toFixed(0) + " hr"}</TableCell>


                                                                                        <TableCell>{detail.nameOfTheSubstitute.name}</TableCell>
                                                                                        <TableCell>



                                                                                            <Link className='pi pi-trash ml-3  ' onClick={() => {
                                                                                                onClickRemoved(i, detailIndex, detail)
                                                                                            }}></Link></TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </Fragment>
                                                                        ))
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </Paper>
                                                    }

                                                </div>
                                            </div>






                                        </div>
                                        {/*---Preview Section---*/}
                                        <div className="mt-[1.250vw]">
                                            <div className="flex flex-wrap justify-between items-center">
                                                <div className="">
                                                    <Link to={"/approver/weekly_absent_report_certificated_admin"} className="text-[#344054] text-xs xl:text-[0.938vw] font-medium bg-white inline-block border border-[#D0D5DD] rounded xl:rounded-lg py-[0.833vw] px-[2.017vw] box-shadow-2"><i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i>Previous</Link></div>
                                                {
                                                    visible &&
                                                    <div className="space-x-4">
                                                        <Link onClick={() => saveReport(Request_Status.O)} className="font-medium inline-block text-[#667085] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw]">Save</Link>
                                                        <Link onClick={() => {
                                                            setVisibleDialogue(true)
                                                        }} className="font-medium inline-block text-[#FFFFFF] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#113699] border border-[#F2F4F7]">Submit</Link>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <Dialog
                                        header="Add New Employee" draggable={false} className='add_New_Employee'
                                        visible={openNewEmployee}
                                        style={{ width: "30vw" }}

                                        onHide={() => {
                                            setOpenNewEmployee(false);

                                        }}
                                    // footer={footerContentForReqReject}
                                    >
                                        <div className="m-0">

                                            <div className="font-medium text-sm mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                            <Dropdown id="dept" value={selectedSchool}
                                                onChange={(e) => { EmployeeList(e); setNewEmployeeSchool(e.value) }}
                                                filter
                                                disabled={disabled}
                                                options={schoolList} optionLabel="name" placeholder="Select School/Department" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                            {/* <div className="font-medium text-[18px] mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                        <InputText
                                            value={NewEmployeeName}
                                            placeholder=""
                                            onChange={e => { setNewEmployeeName(e.target.value) }}
                                            className="w-full"
                                        /> */}
                                            <div className="font-medium text-sm mb-2 mt-3">First Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={newEmpFirstName}
                                                placeholder="Enter First Name"
                                                onChange={e => { setNewEmpFirstName(e.target.value) }}
                                                className="w-full"
                                            />
                                            <div className="font-medium text-sm mb-2 mt-3">Last Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={newEmpLastName}
                                                placeholder="Enter Last Name"
                                                onChange={e => { setNewEmpLastName(e.target.value) }}
                                                className="w-full"
                                            />
                                           {/*  <div className="font-medium text-[18px] mb-2 mt-3">Select Role 
                                            <span className="text-[red] pl-0.2">*</span>
                                            </div>
                                            <Dropdown value={newEmpSelectedRole} onChange={(e) => setNewEmpSelectedRole(e.value)} options={rolesArray} optionLabel="name"
                                                placeholder="Select a Role" className="w-full md:w-14rem" />

                                            <div className="font-medium text-[18px] mb-2 mt-3">Designation<span className="text-[red] pl-0.2">*</span></div>
                                            <Dropdown value={newEmpSelectedDesignation} onChange={(e) => setNewEmpSelectedDesignation(e.value)} options={designationForAllApps} optionLabel="name"
                                                placeholder="Select a Designation" className="w-full md:w-14rem" /> */}
                                            {/* -------------------------------- */}

                                            <div className="font-medium text-sm mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeCode}
                                                placeholder="Enter Employee Code"
                                                onChange={e => { setNewEmployeeCode(e.target.value) }}
                                                className="w-full"
                                            />

                                            <div className="font-medium text-sm mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeEmail}
                                                placeholder="Enter Employee Email Address"
                                                onChange={e => { setNewEmployeeEmail(e.target.value) }}
                                                className="w-full"
                                            />


                                            <div className="font-medium text-sm mb-2 mt-3">Employee Type <span className="text-[red] pl-0.2">*</span></div>
                                            <Dropdown id="employee"
                                                value={employeeTypeField}
                                                onChange={(e) => { setEmployeeTypeField(e.value); }} options={employeeTypeList}
                                                filter
                                                optionLabel="name" placeholder="Select Employee Type" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />


                                        </div>
                                        <div className='flex justify-between gap-2 mt-3'>
                                            <Link to="" onClick={() => { setOpenNewEmployee(false); }}
                                                className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                <i class="pi pi-times"></i><span>Cancel</span></Link>

                                            <Link to="" onClick={() => { AddNewEmployee() }}
                                                className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                <i class="pi pi-check"></i><span>Add</span></Link>

                                        </div>
                                    </Dialog>

                                    <div className="col-span-12 lg:col-span-4">
                                        <div className="bg-white box-shadow-1 p-4 rounded-lg xl:p-[0.833vw]">
                                            <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Selected Dates</p></div>
                                            {
                                                isShowSelectedDate &&
                                                selectedDateRecord.map((currentItem, i) => {
                                                    return (
                                                        <div key={i}>
                                                            <div className="mt-[24px] xl:mt-[1.250vw]">
                                                                <div className="text-[#344054] font-normal text-xs xl:text-[0.625vw] flex flex-wrap items-center justify-between lg:flex-nowrap"><p className="w-full lg:w-[7.813vw] text-[11px] font-bold">{moment(currentItem.displayDate).format("D MMMM YYYY")}</p><span className="w-full h-[1px] bg-[#E4E7EC] inline-block"></span></div>
                                                            </div>
                                                            <div className="mt-[16px] xl:mt-[0.833vw]">
                                                                <div className="bg-[#F2F4F7] rounded p-2 xl:p-[0.417vw] custseledate">
                                                                    <div className="w-full">
                                                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Absent Code <span className='text-[red] pl-0.2'>*</span></label>
                                                                        <Dropdown
                                                                            filter
                                                                            value={currentItem.absentCode} onChange={(e) => { onClickAbsentCode(i, e) }} options={absentCodeListDropdown} optionLabel="name" placeholder="Select an Absent Code" className="w-full h-7 absent" />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Substitute </label>
                                                                        <Dropdown
                                                                            filter
                                                                            value={currentItem.nameOfTheSubstitute} onChange={(e) => onClickNameOfSubstitute(i, e)} options={updatedEmpList} optionLabel="name" placeholder="Select a Substitute" className="w-full h-7" />
                                                                    </div>

                                                                    <div className="p-[8px] mt-[8px] xl:mt-[0.417vw] xl:p-[0.417vw]">
                                                                        <div className="flex flex-wrap gap-3">
                                                                            {
                                                                                <div className="">
                                                                                    <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Total Hours<span className='text-[red] '>*</span></label>
                                                                                    <div className="flex">
                                                                                        <div className="relative custinput-h">
                                                                                            <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC]"><p>H</p></div>
                                                                                            <InputNumber inputId="integeronly" value={currentItem.hour}
                                                                                                maxLength={2} max="24"
                                                                                                onValueChange={(e) => { onClickHoure(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                        </div>

                                                                                        <div className="relative custinput-m">
                                                                                            <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC] rounded-br-[5px] rounded-tr-[5px]"><p>M</p></div>
                                                                                            <InputNumber value={currentItem.minute}
                                                                                                maxLength={2} max="59"
                                                                                                onValueChange={(e) => { onClickMin(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            {
                                                selectedDateRecord >= 0 ? null : <div className="custbutn mt-6 xl:mt-[1.250vw]">
                                                    <Button className="" label={showPleaseWaitButton ? 'Please wait...' : 'Apply'} onClick={() => {
                                                        applyReport()
                                                    }}>
                                                    </Button>
                                                </div>

                                            }



                                        </div>

                                        <div className="bg-white box-shadow-1 p-4 mt-6 rounded-lg xl:p-[0.833vw] xl:mt-[1.250vw]">
                                            <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Absence Codes - Legends</p></div>
                                            <div className="flex flex-wrap xl:flex-nowrap gap-4 mt-5 xl:gap-[0.938vw] xl:mt-[1.250vw]">


                                                <div className="text-[#344054] font-semibold text-xs xl:text-[0.729vw] space-y-1">
                                                    {absentCodeList.length > 0 && absentCodeList.slice(0, 7).map((item, index) => {
                                                        return (<>
                                                            <p>{item.code} - <span className="font-normal">{item.name}</span></p>
                                                        </>
                                                        )
                                                    })}
                                                </div>

                                                <div className="text-[#344054] font-semibold text-xs xl:text-[0.729vw] space-y-1">
                                                    {absentCodeList.length > 0 && absentCodeList.slice(7, 14).map((item, index) => {
                                                        return (<>
                                                            <p>{item.code} - <span className="font-normal">{item.name}</span></p>
                                                        </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dialogpoput flex justify-content-center ">
                                        <Dialog visible={visibleDialogue} position="center" style={{ width: '30vw' }} className="dialogpoput dialogres submit_popup" onHide={() => setVisibleSumbit(false)}>

                                            <div className="text-[#101828] text-lg py-2 pt-5 font-bold text-center">Submit Report</div>
                                            <div className="text-[#344054] text-xs pb-2 font-medium">Your report will be sent for review, you will be notified of updates.</div>

                                            <div className="pt-2 flex pb-[-2px] justify-center gap-2">
                                                <Link href={''} className="custmBtn3 rounded-lg text-[black] text-center bg-[White]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                }}
                                                > Cancel
                                                </Link>
                                                <Link href={''} className="custmBtn3 rounded-lg text-[#FFFFFF] text-center bg-[#113699]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                    saveReport(Request_Status.AP)
                                                    // submitReport()
                                                }}
                                                >Send
                                                </Link>
                                            </div>

                                        </Dialog>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </Layout>
        </>

    ) : (
        <Login sessionExpired={1} />
    );
}